<template>
  <div class="container thank-you">
    <div class="row pt-4">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t("thankYou.title")}}
        </label>
      </div>
    </div>
    <div class="row pt-5 pb-4">
      <div class="col-12 offset-md-4 col-md-4 text-center">
        <img class="img-question" src="../assets/thank_you.svg" alt="thank-you">
      </div>
    </div>
    <div class="row pt-4">
      <div class="offset-0 col-12 offset-lg-2 col-lg-8 text-center info">
        <label>
          {{ $t('thankYou.info') }}
        </label>
      </div>
    </div>
    <div class="row row-agree">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light next" @click="agree(true)">
          {{ $t('thankYou.agree') }}
        </button>
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light not-agree" @click="agree(false)">
          {{ $t('thankYou.notAgree') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  computed: {
    surveyComplete () {
      return this.$store.getters.SurveyComplete
    }
  },
  methods: {
    agree (status) {
      this.$swal({
        title: this.$t('thankYou.sendingData')
      })

      this.$swal.showLoading()

      const self = this

      firebase.auth().signInAnonymously().catch(function (error) {
        console.log(error)
      })

      firebase.auth().onAuthStateChanged(async function (user) {
        if (user) {
          try {
            let token = await user.getIdToken(true)

            await self.$store.commit('SET_AUTHORIZATION', token)

            if (!self.surveyComplete && status) {
              await self.$store.dispatch('generateWords')

              await self.$store.dispatch('register')

              await self.$store.dispatch('saveSurvey')

              self.$swal.close()

              self.$router.push({
                name: 'results'
              })
            } else {
              self.$swal.close()

              self.$router.push({
                name: 'results'
              })
            }
          } catch (error) {
            self.$swal.close()
          }
        }
      })
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'thankyou')
  }
}
</script>

<style>
.thank-you .title {
  font-weight: 700;
  font-size: 1.4rem;
}

.thank-you .img-question {
  width: 100%;
  height: 30vh;
}

.thank-you .info {
  font-size: 1.1rem;
}

.thank-you .row-agree {
  padding-top: 3.5rem;
}

.thank-you .next {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

.thank-you .not-agree {
  width: 85%;
  min-height: 83px;
  color: #2bb1c4 !important;
  border: 1px solid #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

@media screen and (device-aspect-ratio: 40/71) {
  .thank-you .title {
    font-size: 1.2rem;
  }

  .thank-you .img-question {
    width: 100%;
    height: 21vh;
  }

  .thank-you .info {
    font-size: .8rem;
  }

  .thank-you .row-agree {
    padding-top: 1rem;
  }

  .thank-you .next {
    min-height: 70px;
  }

  .thank-you .not-agree {
    min-height: 70px;
  }
}
</style>
